import {Redirect} from "react-router-dom";
import {useEffect} from "react";

import appHistory from "../../app/appHistory";
import {isClientMobile} from "../../components/ClientInfo/ClientInfo";
import {Loader} from "../../components/Loader/Loader";
import {MainHeader} from "../../components/main-header/MainHeader";
import {useZendeskContext} from "../Zendesk/zendeskContext";
import {RouterPaths} from "../../app/appConstants";

export const Support = () => {
    const { isWebWidgetInited, openWebWidget, setOnWidgetCloseCallback } = useZendeskContext();

    useEffect(() => {
        if (isWebWidgetInited) {
            openWebWidget();
            if (isClientMobile) {
                setOnWidgetCloseCallback(() => appHistory.push(RouterPaths.main));
                return () => {
                    setOnWidgetCloseCallback(null)
                }
            } else {
                appHistory.push(RouterPaths.main);
            }
        }
    }, [isWebWidgetInited, openWebWidget, setOnWidgetCloseCallback])

    return <>
        <MainHeader/>
        <Loader show/>
    </>
}